export const getLocationPathName = (): string =>
  (typeof window !== "undefined" && window.location.pathname) || "";

export const goToURL = (where: string) => {
  window.location.href = where;
};
